//系统参数配置
import { postEvent } from '../public'

//合同流程
export const doGetContractFlow = ({ ...rest } = {}) => {
  return postEvent({
    event: 'GetContractFlow',
    data: {},
    ...rest
  })
}
export const doSaveContractFlow = ({ strContractFlow, ...rest } = {}) => {
  return postEvent({
    event: 'SaveContractFlow',
    data: { strContractFlow },
    ...rest
  })
}
//样品流程
export const doGetSampleFlow = ({ ...rest } = {}) => {
  return postEvent({
    event: 'GetSampleFlow',
    data: {},
    ...rest
  })
}
export const doSaveSampleFlow = ({ strSampleFlow, ...rest } = {}) => {
  return postEvent({
    event: 'SaveSampleFlow',
    data: { strSampleFlow },
    ...rest
  })
}
//外出流程
export const doGetOutApplyFlow = ({ ...rest } = {}) => {
  return postEvent({
    event: 'GetOutApplyFlow',
    data: {},
    ...rest
  })
}
export const doSaveOutApplyFlow = ({ strOutApplyFlow, ...rest } = {}) => {
  return postEvent({
    event: 'SaveOutApplyFlow',
    data: { strOutApplyFlow },
    ...rest
  })
}
//自定义模板2
export const doGetCustomTemplateList = ({ ...rest } = {}) => {
  return postEvent({
    event: 'GetCustomTemplateList',
    data: {},
    ...rest
  })
}

export const doGetCustomTemplate = ({ id, ...rest }) => {
  return postEvent({
    event: 'GetCustomTemplate',
    data: { id },
    ...rest
  })
}

export const doSaveCustomTemplate = ({ id, changedValues基本信息, ...rest }) => {
  return postEvent({
    event: 'SaveCustomTemplate',
    data: {
      id,
      changedValues基本信息,
    },
    ...rest
  })
}

export const doDeleteCustomTemplate = ({ id, ...rest }) => {
  return postEvent({
    event: 'DeleteCustomTemplate',
    data: { id },
    ...rest
  })
}
//
export const doDefultCoordinator = ({ ...rest } = {}) => {
  return postEvent({
    event: 'DefultCoordinator',
    data: {},
    ...rest
  })
}
//公共标签打印模板
export const doGetPrintTemplateList = ({ ...rest } = {}) => {
  return postEvent({
    event: 'GetPrintTemplateList',
    data: {},
    ...rest
  })
}

export const doGetPrintTemplate = ({ id, ...rest }) => {
  return postEvent({
    event: 'GetPrintTemplate',
    data: { id },
    ...rest
  })
}

export const doSavePrintTemplate = ({ id, changedValues基本信息, ...rest }) => {
  return postEvent({
    event: 'SavePrintTemplate',
    data: {
      id,
      changedValues基本信息,
    },
    ...rest
  })
}

export const doDeletePrintTemplate = ({ id, ...rest }) => {
  return postEvent({
    event: 'DeletePrintTemplate',
    data: { id },
    ...rest
  })
}
//公文模板
export const doGetArchivesTempletList = ({ ...rest } = {}) => {
  return postEvent({
    event: 'GetArchivesTempletList',
    data: {},
    ...rest
  })
}

export const doGetArchivesTemplet = ({ id, ...rest }) => {
  return postEvent({
    event: 'GetArchivesTemplet',
    data: { id },
    ...rest
  })
}

export const doSaveArchivesTemplet = ({ id, changedValues基本信息, ...rest }) => {
  return postEvent({
    event: 'SaveArchivesTemplet',
    data: {
      id,
      changedValues基本信息,
    },
    ...rest
  })
}

export const doDeleteArchivesTemplet = ({ id, ...rest }) => {
  return postEvent({
    event: 'DeleteArchivesTemplet',
    data: { id },
    ...rest
  })
}
//合同/样品编号规则
export const doGetNumberRuleList = ({ name, ...rest } = {}) => {
  return postEvent({
    event: 'GetNumberRuleList',
    data: { name },
    ...rest
  })
}

export const doGetNumberRule = ({ id, ...rest }) => {
  return postEvent({
    event: 'GetNumberRule',
    data: { id },
    ...rest
  })
}

export const doSaveNumberRule = ({ id, changedValues基本信息, name, ...rest }) => {
  return postEvent({
    event: 'SaveNumberRule',
    data: {
      id,
      changedValues基本信息,
      name
    },
    ...rest
  })
}

export const doDeleteNumberRule = ({ id, ...rest }) => {
  return postEvent({
    event: 'DeleteNumberRule',
    data: { id },
    ...rest
  })
}
//邮件模板
export const doGetEmailTempletList = ({ ...rest } = {}) => {
  return postEvent({
    event: 'GetEmailTempletList',
    data: {},
    ...rest
  })
}

export const doGetEmailTemplet = ({ id, ...rest }) => {
  return postEvent({
    event: 'GetEmailTemplet',
    data: { id },
    ...rest
  })
}

export const doSaveEmailTemplet = ({ id, changedValues基本信息, ...rest }) => {
  return postEvent({
    event: 'SaveEmailTemplet',
    data: {
      id,
      changedValues基本信息,
    },
    ...rest
  })
}

export const doDeleteEmailTemplet = ({ id, ...rest }) => {
  return postEvent({
    event: 'DeleteEmailTemplet',
    data: { id },
    ...rest
  })
}

//系统服务
export const doGetSysService = ({ id, ...rest } = {}) => {
  return postEvent({
    event: 'GetSysService',
    data: { id },
    ...rest
  })
}

export const doSaveSysService = ({ id, changedValues基本信息, ...rest }) => {
  return postEvent({
    event: 'SaveSysService',
    data: {
      id,
      changedValues基本信息,
    },
    ...rest
  })
}

export const doDeleteSysService = ({ id, ...rest }) => {
  return postEvent({
    event: 'DeleteSysService',
    data: { id },
    ...rest
  })
}
//自动编号规则
export const doGetAutoNumberList = ({ ...rest } = {}) => {
  return postEvent({
    event: 'GetAutoNumberList',
    data: {},
    ...rest
  })
}

export const doGetAutoNumber = ({ id, ...rest }) => {
  return postEvent({
    event: 'GetAutoNumber',
    data: { id },
    ...rest
  })
}

export const doSaveAutoNumber = ({ id, changedValues基本信息, ...rest }) => {
  return postEvent({
    event: 'SaveAutoNumber',
    data: {
      id,
      changedValues基本信息,
    },
    ...rest
  })
}

export const doDeleteAutoNumber = ({ id, ...rest }) => {
  return postEvent({
    event: 'DeleteAutoNumber',
    data: { id },
    ...rest
  })
}

export const doGetAutoNumberRuleList = ({ id, ...rest } = {}) => {
  return postEvent({
    event: 'GetAutoNumberRuleList',
    data: { id },
    ...rest
  })
}

export const doGetAutoNumberRule = ({ id, ...rest }) => {
  return postEvent({
    event: 'GetAutoNumberRule',
    data: { id },
    ...rest
  })
}

export const doSaveAutoNumberRule = ({ id, AutoNumberID, changedValues基本信息, ...rest }) => {
  return postEvent({
    event: 'SaveAutoNumberRule',
    data: {
      id,
      AutoNumberID,
      changedValues基本信息,
    },
    ...rest
  })
}
export const doDeleteAutoNumberRule = ({ id, ...rest }) => {
  return postEvent({
    event: 'DeleteAutoNumberRule',
    data: { id },
    ...rest
  })
}

export const doGetAutoNumberSequenceList = ({ id, ...rest } = {}) => {
  return postEvent({
    event: 'GetAutoNumberSequenceList',
    data: { id },
    ...rest
  })
}

export const doGetAutoNumberSequence = ({ id, ...rest }) => {
  return postEvent({
    event: 'GetAutoNumberSequence',
    data: { id },
    ...rest
  })
}

export const doSaveAutoNumberSequence = ({ id, AutoNumberID, changedValues基本信息, ...rest }) => {
  return postEvent({
    event: 'SaveAutoNumberSequence',
    data: {
      id,
      AutoNumberID,
      changedValues基本信息,
    },
    ...rest
  })
}
export const doDeleteAutoNumberSequence = ({ id, ...rest }) => {
  return postEvent({
    event: 'DeleteAutoNumberSequence',
    data: { id },
    ...rest
  })
}
//部门
export const doGetDepList = ({ ...rest } = {}) => {
  return postEvent({
    event: 'GetDepList',
    data: {},
    ...rest
  })
}
export const doGetDep = ({ id, fatherID, ...rest } = {}) => {
  return postEvent({
    event: 'GetDep',
    data: { id, fatherID },
    ...rest
  })
}

export const doSaveDep = ({ id, fatherID, depth, changedValues基本信息, ...rest } = {}) => {
  return postEvent({
    event: 'SaveDep',
    data: { id, fatherID, depth, changedValues基本信息 },
    ...rest
  })
}

export const doDelDep = ({ id, ...rest } = {}) => {
  return postEvent({
    event: 'DelDep',
    data: { id, },
    ...rest
  })
}
//小组
export const doGetTeam = ({ id, depID, ...rest } = {}) => {
  return postEvent({
    event: 'GetTeam',
    data: { id, depID },
    ...rest
  })
}

export const doSaveTeam = ({ id, depID, changedValues基本信息, ...rest } = {}) => {
  return postEvent({
    event: 'SaveTeam',
    data: { id, depID, changedValues基本信息 },
    ...rest
  })
}

export const doDelTeam = ({ id, ...rest } = {}) => {
  return postEvent({
    event: 'DelTeam',
    data: { id, },
    ...rest
  })
}

//人员
export const doGetPersonList = ({ depID, searchString, ...rest } = {}) => {
  return postEvent({
    event: 'GetPersonList',
    data: { depID, searchString },
    ...rest
  })
}

export const doGetPerson = ({ id, depID, ...rest } = {}) => {
  return postEvent({
    event: 'GetPerson',
    data: { id, depID },
    ...rest
  })
}

export const doSavePerson = ({ id, depID, changedValues基本信息, changedValues通讯资料, changedValues在职资料, ...rest } = {}) => {
  return postEvent({
    event: 'SavePerson',
    data: { id, depID, changedValues基本信息, changedValues通讯资料, changedValues在职资料 },
    ...rest
  })
}

//打印机端口
export const doGetPrinterList = ({ ...rest } = {}) => {
  return postEvent({
    event: 'GetPrinterList',
    data: {},
    ...rest
  })
}

export const doGetPrinterPort = ({ id, ...rest } = {}) => {
  return postEvent({
    event: 'GetPrinterPort',
    data: { id },
    ...rest
  })
}

export const doSavePrinterPort = ({ id, changedValues基本信息, ...rest } = {}) => {
  return postEvent({
    event: 'SavePrinterPort',
    data: { id, changedValues基本信息 },
    ...rest
  })
}

export const doDeletePrinterPort = ({ id, ...rest } = {}) => {
  return postEvent({
    event: 'DeletePrinterPort',
    data: { id },
    ...rest
  })
}

//标签打印
export const doPrintLabel = ({ id, ...rest } = {}) => {
  return postEvent({
    event: 'PrintLabel',
    data: { id },
    ...rest
  })
}

export const doPrintGaugeLabel = ({ id, ...rest } = {}) => {
  return postEvent({
    event: 'PrintGaugeLabel',
    data: { id },
    ...rest
  })
}

//邮件
export const doGetEmail = ({ id, ...rest }) => {
  return postEvent({
    event: 'GetEmail',
    data: { id },
    ...rest
  })
}

export const doSendEmail = ({ id, ...rest }) => {
  return postEvent({
    event: 'SendEmail',
    data: {
      id,
    },
    ...rest
  })
}
// 班别管理
export const doGetShiftList = ({ ...rest }) => {
  return postEvent({
    event: 'GetShiftList',
    data: {
    },
    ...rest
  })
}

export const doGetShift = ({ id, ...rest }) => {
  return postEvent({
    event: 'GetShift',
    data: {
      id
    },
    ...rest
  })
}

export const doSaveShift = ({ id, changedValues基本信息, ...rest }) => {
  return postEvent({
    event: 'SaveShift',
    data: {
      id,
      changedValues基本信息
    },
    ...rest
  })
}

export const doDeleteShift = ({ id, ...rest }) => {
  return postEvent({
    event: 'DeleteShift',
    data: {
      id
    },
    ...rest
  })
}

// 人员附件分类
export const doGetPersonAttachKindList = ({ ...rest }) => {
  return postEvent({
    event: 'GetPersonAttachKindList',
    data: {
    },
    ...rest
  })
}

export const doGetPersonAttachKind = ({ id, ...rest }) => {
  return postEvent({
    event: 'GetPersonAttachKind',
    data: {
      id
    },
    ...rest
  })
}

export const doSavePersonAttachKind = ({ id, changedValues基本信息, ...rest }) => {
  return postEvent({
    event: 'SavePersonAttachKind',
    data: {
      id,
      changedValues基本信息
    },
    ...rest
  })
}

export const doDeletePersonAttachKind = ({ id, ...rest }) => {
  return postEvent({
    event: 'DeletePersonAttachKind',
    data: {
      id
    },
    ...rest
  })
}


export const doGetSalaryAccount = ({ ...rest } = {}) => {
  return postEvent({
    event: 'GetSalaryAccount',
    data: {},
    ...rest
  })
}
export const doSaveSalaryAccount = ({ strSalaryAccount, ...rest } = {}) => {
  return postEvent({
    event: 'SaveSalaryAccount',
    data: { strSalaryAccount },
    ...rest
  })
}

export const doGetSalaryAdjustment = ({ ...rest } = {}) => {
  return postEvent({
    event: 'GetSalaryAdjustment',
    data: {},
    ...rest
  })
}
export const doSaveSalaryAdjustment = ({ strSalaryAdjustment, ...rest } = {}) => {
  return postEvent({
    event: 'SaveSalaryAdjustment',
    data: { strSalaryAdjustment },
    ...rest
  })
}

export const doGetSalary = ({ ...rest } = {}) => {
  return postEvent({
    event: 'GetSalary',
    data: {},
    ...rest
  })
}
export const doSaveSalary = ({ strSalary, ...rest } = {}) => {
  return postEvent({
    event: 'SaveSalary',
    data: { strSalary },
    ...rest
  })
}

export const doGetBonus = ({ ...rest } = {}) => {
  return postEvent({
    event: 'GetBonus',
    data: {},
    ...rest
  })
}
export const doSaveBonus = ({ strBonus, ...rest } = {}) => {
  return postEvent({
    event: 'SaveBonus',
    data: { strBonus },
    ...rest
  })
}